import * as DrawingApi from '../api/archibus/DrawingApi'

const svgRegEx = /<svg(.*?)>/g
/**
 * Extract the SVG attributes from the SVG text string.
 *   - Extract the enclosing SVG tag from the string
 *   - Parse the SVG string to create an SVG element
 *   - Extract the attributes and create a props object. Note: xmlns attributes are not supported by React
 *     so we ignore them.
 *
 * @param {String} svgText the SVG file as a string
 */
const getSvgAttributes = svgText => {
  let svgElText = svgText.match(svgRegEx)
  let props = {}

  if (svgElText) {
    // Add the enclosing SVG tag and parse the string.
    let svgContainer = svgElText + '</svg>'
    let svgEl = new DOMParser().parseFromString(svgContainer, 'image/svg+xml')
    let attributes = svgEl.documentElement.attributes
    // Get the attributes
    Object.keys(attributes).map(key => {
      let attributeItem = attributes.item(key)
      if (attributeItem.name.indexOf('xmlns') === -1) {
        props[attributeItem.name] = attributeItem.value
      }
    })
  }

  return props
}

const svgCache = {}

export const fetchSvgData = async ({blId, flId}) => {
  // Get the item from cache if it exists
  let cacheKey = `${blId}|${flId}`

  if (svgCache[cacheKey]) {
    return svgCache[cacheKey]
  } else {
    let svgData = null
    let attributes = {}
    let svg = null
    try {
      svg = await DrawingApi.getDrawingSVGFromServer(
        {
          bl_id: blId,
          fl_id: flId
        },
        null,
        null
      )

      if (svg) {
        attributes = getSvgAttributes(svg)

        // Extract the inner SVG elements
        svgData = svg.replace('</svg>', '').replace(svgRegEx, '')

        // Add item to the cache
        svgCache[cacheKey] = {svgData, attributes, hasDrawing: true}
      }
    } catch (error) {
      console.log('Error fetching floor plan for floor: ', cacheKey)
    }

    return {svgData, attributes, hasDrawing: !!svg}
  }
}

let counter = 0
export const checkElement = selector => {
  const rafAsync = () => new Promise(resolve => requestAnimationFrame(resolve))

  // Cancel element check after counter reaches 200.
  if (counter > 200) {
    counter = 0
    return Promise.reject()
  } else if (document.getElementById(selector) === null) {
    counter += 1
    return rafAsync().then(() => checkElement(selector))
  } else {
    counter = 0
    return Promise.resolve(true)
  }
}
